import type { IResponse, ISuggest } from '../../types';
import { buildApiUrl } from '../../utils/build-api-url';
import { fetchGet } from '../service';

let oldTerm = '';
let oldResponse: Promise<IResponse<ISuggest> | null> = Promise.resolve(null);

export async function getSuggest(
  searchTerm: string,
  cmsNativeLanguage: string,
  pimLanguage: string,
): Promise<IResponse<ISuggest> | null> {
  const trimmedTerm = searchTerm?.trim().replace(/\s+/g, ' ');

  if (!trimmedTerm) return null;
  if (trimmedTerm === oldTerm) return oldResponse;

  oldTerm = trimmedTerm;

  const url = buildApiUrl('suggest', {
    cmsNativeLanguage,
    pimLanguage,
    searchTerm: trimmedTerm,
  });

  const response = fetchGet<ISuggest>(url);
  oldResponse = response;

  return response;
}
